import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTabs, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        class: _normalizeClass(_ctx.b('tab', { active: tab.isActive })),
        key: tab.id,
        onClick: ($event: any) => (_ctx.handleTab(tab))
      }, _toDisplayString(_ctx.$t(tab.label)), 11, _hoisted_1))
    }), 128))
  ], 2))
}